import React, { useState } from 'react';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import { notNull } from 'utils/text';
import WrapWithContainer from '../CommonWrapper';
import { MyDatePickerContainer } from './style';

const moment = require('moment-timezone');

const MyDatePicker = ({ id, label = null, placeholder = 'Input', value, values, onChange = () => {}, ...otherProps }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <MyDatePickerContainer>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <KeyboardDatePicker
          open={isOpen}
          onClose={() => setIsOpen(false)}
          variant="inline"
          inputVariant="outlined"
          format="MM/dd/yyyy"
          label={label}
          value={value && moment(value).isValid() ? moment(value) : (values && notNull(values[id]) && moment(values[id]).isValid() ? moment(values[id]) : null)}
          onChange={(date, val) => { 
            onChange(id, val);
            setIsOpen(false);
          }}
          InputAdornmentProps={{
            onClick: () => setIsOpen(true),
          }}
          size="small"
          {...otherProps}
        />
      </MuiPickersUtilsProvider>
    </MyDatePickerContainer>
  )
};

export default WrapWithContainer(MyDatePicker);
